// @ts-nocheck
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isCommonAuthEnabled } from '../../const/commonAuthConfig';
import { redirectToLogout } from '../../utils/commonAuthUtils';

/**
 * CommonAuthGuard Component
 * Redirects users to logout URL when common auth is enabled
 * and they try to access custom auth routes (login, account, etc.)
 */
const CommonAuthGuard = ({ children }) => {
  useEffect(() => {
    // If common auth is enabled, redirect to logout URL
    // This prevents access to custom auth login pages
    if (isCommonAuthEnabled()) {
      redirectToLogout(500); // Small delay for UX
      return;
    }
  }, []);

  // If common auth is enabled, don't render children (will redirect)
  if (isCommonAuthEnabled()) {
    return null;
  }

  // Common auth is disabled, render the children (login pages)
  return children;
};

CommonAuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CommonAuthGuard;
